// import { isMobile } from '../../components/Common/Helpers/useragent';

import { getURL } from '../UrlMapperService';

/* This file contains the URL Mapping of all the pages inside our application
 * KEY - ProcessStep Value
 * VALUE - URL to be redirected to for the given processstep key . */

export const URL_MAPPER_MOVERS = {
  GENERIC_ERROR: getURL('error.html'),
  MOVERS_APPOINTMENT: getURL('appointment.html'),
  MOVERS_ORDER_REVIEW: getURL('orderReview.html'),
  MOVERS_CONFIRMATION: getURL('confirmation.html'),
  MOVERS_PLANS_OVER_VIEW: getURL('plansOverview.html'),
  MOVERS_SHIPPING: getURL('moversShipping.html'),
  MOVERS_PAYMENT: getURL('moversPayment.html'),
  MOVERS_DEVICE_SET_UP: getURL('moversDeviceSetup.html'),
  MOVERS_EQUIPMENTS: getURL('equipments.html'),
};
